import { useSiteInfoStore } from 'src/stores/site-info'
import { BASE_URL } from 'src/common/config'

export default class {
  constructor($this) {
    this.$this = $this
  }

  inLanguage = ['ru-RU', 'en-US', 'kk-KZ', 'uz-UZ', 'uz-Cyrl-UZ', 'uk-UA', 'az-AZ', 'ky-KY', 'hi-IN']

  get URL() {
    return `https://${useSiteInfoStore().getMainDomain}${BASE_URL}`
  }

  isPartOf() {
    return {
      '@type': 'WebSite',
      '@id': `${this.URL}/ru/#website`,
      url: `${this.URL}/ru/`,
      name: 'Онлайн-казино Olimp',
      description: null,
      inLanguage: this.inLanguage,
    }
  }

  publisher() {
    return {
      '@type': 'Organization',
      '@id': `${this.URL}/ru/#organization`,
      name: 'Онлайн-казино Olimp',
      url: `${this.URL}/ru/`,
    }
  }

  translator() {
    return {
      '@type': 'Organization',
      '@id': `${this.URL}/ru/#organization`,
      url: `${this.URL}/ru/`,
      name: 'Онлайн-казино Olimp',
      logo: {
        '@type': 'ImageObject',
        url: `${this.URL}/img/logo.svg`,
        width: '25',
        height: '25',
      },
    }
  }

  logo() {
    return {
      '@type': 'ImageObject',
      url: `${this.URL}/img/logo.svg`,
      contentUrl: `${this.URL}/img/logo.svg`,
      width: '25',
      height: '25',
    }
  }

  authorCasino() {
    return {
      '@type': 'Organization',
      '@id': `${this.URL}/ru/#organization`,
      name: 'Онлайн-казино Olimp',
      url: `${this.URL}/ru/`,

      logo: this.logo(),
    }
  }

  parseH1(str) {
    if (typeof str !== 'string') {
      return ''
    }

    const array = str.match(/<h1>(\d|\D*?)<\/h1>/)
    const html = array ? array[1] : ''

    const regex = /(<([^>]+)>)/gi
    return html.replace(regex, '')
  }

  parseHeadline(str) {
    if (typeof str !== 'string') {
      return ''
    }

    const array = str.match(/<p>(\d|\D*?)<\/p>/)
    const html = array ? array[1] : ''

    const regex = /(<([^>]+)>)/gim
    return html.replace(regex, '')
  }

  breadcrumb(breadcrumbsArray = []) {
    const array = breadcrumbsArray.map((item, index) => {
      return {
        '@type': 'ListItem',
        position: index + 2,
        item: item,
      }
    })

    return {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            type: 'Thing',
            '@id': `${this.URL}/ru/`,
            name: '🎰Онлайн-казино Olimp',
          },
        },
        ...array,
      ],
    }
  }
}
